<app-card-content [border]="false" [headerColor]="true" icon="pi pi-building" title="Novo Consultório Privado" subtitle="Cadastro de novo consultório privado">
    <!-- Indicador de Etapas -->
    <div class="flex items-center gap-4 mb-6">
        <div class="flex flex-wrap items-center gap-2 text-sm">
            <span class="font-semibold" [class.text-primary-600]="novoStep === 0">Dados do Consultório</span>
            <i class="pi pi-angle-right text-gray-400"></i>
            <span class="font-semibold" [class.text-primary-600]="novoStep === 1">Telefone</span>
            <i class="pi pi-angle-right text-gray-400"></i>
            <span class="font-semibold" [class.text-primary-600]="novoStep === 2">Horários</span>
            @if (novoForm.controls.inUso.value === 'C') {
                <i class="pi pi-angle-right text-gray-400"></i>
                <span class="font-semibold" [class.text-primary-600]="novoStep === compartStepIndex">Compartilhamento</span>
            }
            @if (novoForm.controls.inEspecializado.value) {
                <i class="pi pi-angle-right text-gray-400"></i>
                <span class="font-semibold" [class.text-primary-600]="novoStep === especialStepIndex">Especialidades</span>
            }
        </div>
    </div>

    <!-- Conteúdo das Etapas -->
    @if (novoStep === 0) {
        <div class="flex flex-col gap-4" [formGroup]="novoForm">
            <!-- Dados do Consultório -->
            <app-card-content [headerColor]="false" icon="pi pi-building" title="Dados do Consultório">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-4 items-start">
                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Número CNES</label>
                        <input pInputText class="w-full" formControlName="nuCnes" inputmode="numeric" pattern="[0-9]*" />
                    </div>
                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Uso</label>
                        <p-selectbutton
                            [options]="[
                                { label: 'Exclusivo', value: 'E' },
                                { label: 'Compartilhado', value: 'C' }
                            ]"
                            formControlName="inUso"
                            [multiple]="false"
                        ></p-selectbutton>
                        @if (campoInvalido('inUso')) {
                            <small class="erro-campo">{{ mensagemErroCampo('inUso') }}</small>
                        }
                    </div>
                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Especialidade</label>
                        <p-selectbutton
                            [options]="[
                                { label: 'Sim', value: true },
                                { label: 'Não', value: false }
                            ]"
                            formControlName="inEspecializado"
                            [multiple]="false"
                        ></p-selectbutton>
                        @if (campoInvalido('inEspecializado')) {
                            <small class="erro-campo">{{ mensagemErroCampo('inEspecializado') }}</small>
                        }
                    </div>
                </div>
            </app-card-content>

            <!-- Registro Sanitário -->
            <app-card-content [headerColor]="false" icon="pi pi-file-check" title="Registro Sanitário">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Nº da Licença</label>
                        <input pInputText class="w-full" formControlName="nuRegistroSanitario" inputmode="numeric" pattern="[0-9]*" />
                    </div>
                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Esfera</label>
                        <p-selectbutton
                            [options]="[
                                { label: 'Municipal', value: 'M' },
                                { label: 'Estadual', value: 'E' }
                            ]"
                            formControlName="inTipoRegSanitario"
                            [multiple]="false"
                        ></p-selectbutton>
                    </div>
                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Data de Validade</label>
                        <p-inputmask mask="99/99/9999" class="w-full" formControlName="dtValidadeRegSanitario" placeholder="dd/mm/aaaa" />
                        @if (campoInvalido('dtValidadeRegSanitario')) {
                            <small class="erro-campo">{{ mensagemErroCampo('dtValidadeRegSanitario') }}</small>
                        }
                    </div>
                </div>
            </app-card-content>

            <!-- Alvará de Funcionamento -->
            <app-card-content [headerColor]="false" icon="pi pi-file-edit" title="Alvará de Funcionamento">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Nº do Alvará</label>
                        <input pInputText class="w-full" formControlName="nuAlvara" inputmode="numeric" pattern="[0-9]*" />
                        @if (campoInvalido('nuAlvara')) {
                            <small class="erro-campo">{{ mensagemErroCampo('nuAlvara') }}</small>
                        }
                    </div>
                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Data de Validade</label>
                        <p-inputmask mask="99/99/9999" class="w-full" formControlName="dtValidadeAlvara" placeholder="dd/mm/aaaa" />
                        @if (campoInvalido('dtValidadeAlvara')) {
                            <small class="erro-campo">{{ mensagemErroCampo('dtValidadeAlvara') }}</small>
                        }
                    </div>
                    <div class="md:col-span-4">
                        <!--
                            Rótulo visível: o controle anterior escrevia "Isento"/"Não Isento" nele mesmo,
                            e era a única coisa na tela dizendo do que se tratava — o `invisible` só
                            reservava a altura para alinhar a grade. Com o Sim/Não do padrão, a pergunta
                            precisa estar escrita.
                        -->
                        <label for="inIsencaoAlvara" class="font-semibold block mb-2">Isenção de alvará</label>
                        <app-switch-sim-nao inputId="inIsencaoAlvara" formControlName="inIsencaoAlvara" />
                    </div>
                </div>
            </app-card-content>

            <!-- Endereço -->
            <app-card-content [headerColor]="false" icon="pi pi-map-marker" title="Endereço">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
                    <div class="md:col-span-3">
                        <label class="font-semibold block mb-2">CEP</label>
                        <p-inputmask mask="99999999" class="w-full" formControlName="nuCep" placeholder="Somente números" />
                    </div>
                    <div class="md:col-span-9">
                        <label class="font-semibold block mb-2">Endereço</label>
                        <input pInputText class="w-full" formControlName="txEndereco" placeholder="Rua, número, complemento" [readonly]="true" />
                        @if (campoInvalido('txEndereco')) {
                            <small class="erro-campo">{{ mensagemErroCampo('txEndereco') }}</small>
                        }
                    </div>

                    <div class="md:col-span-4">
                        <label class="font-semibold block mb-2">Bairro</label>
                        <input pInputText class="w-full" formControlName="nmBairro" [readonly]="true" />
                    </div>
                    <div class="md:col-span-8">
                        <label class="font-semibold block mb-2">Município</label>
                        <input pInputText class="w-full cursor-pointer" [value]="municipioSelecionadoLabel() || ''" placeholder="Clique para selecionar o município" readonly (click)="abrirDialogMunicipio()" />
                    </div>

                    <div class="md:col-span-12 flex items-center gap-3 mt-4">
                        <span class="font-semibold">Divulgar Endereço?</span>
                        <p-selectbutton
                            [options]="[
                                { label: 'Sim', value: true },
                                { label: 'Não', value: false }
                            ]"
                            formControlName="inDivulga"
                        ></p-selectbutton>
                    </div>
                </div>
            </app-card-content>
        </div>
    }

    @if (novoStep === 1) {
        <div class="flex flex-col gap-4">
            <!-- Novo Telefone -->
            <app-card-content [headerColor]="false" icon="pi pi-phone" title="Novo Telefone">
                <div class="telefone-form-grid">
                    <div class="telefone-campo telefone-campo--tipo">
                        <label class="font-semibold block mb-2">Tipo</label>
                        <p-select [appendTo]="'body'" class="w-full" [options]="tiposTelefone" optionLabel="label" optionValue="value" [(ngModel)]="novoTelefone.inTipoTelefone" placeholder="Selecione" [style]="{ width: '100%' }"></p-select>
                    </div>
                    <div class="telefone-campo telefone-campo--ddd">
                        <label class="font-semibold block mb-2">DDD</label>
                        <p-inputmask mask="99" class="w-full" [(ngModel)]="novoTelefone.nuDdd" placeholder="Ex: 11" />
                    </div>
                    <div class="telefone-campo telefone-campo--numero">
                        <label class="font-semibold block mb-2">Número de Telefone</label>
                        <p-inputmask [mask]="numeroTelefoneMask" class="w-full" [(ngModel)]="novoTelefone.nuTelefone" placeholder="Ex: 9999-9999" />
                    </div>
                    <div class="telefone-campo telefone-campo--ramal">
                        <label class="font-semibold block mb-2">Ramal</label>
                        <p-inputmask mask="9999" class="w-full" [(ngModel)]="novoTelefone.nuRamal" placeholder="Ex: 1234" />
                    </div>
                    <div class="telefone-campo telefone-campo--observacao">
                        <label class="font-semibold block mb-2">Observação</label>
                        <input pInputText class="w-full" [(ngModel)]="novoTelefone.txObservacao" placeholder="Opcional" />
                    </div>

                    <div class="telefone-acoes">
                        <p-button styleClass="telefone-adicionar-btn" [label]="editingTelefoneIndex >= 0 ? 'Salvar' : 'Adicionar'" icon="pi pi-check" (onClick)="adicionarTelefone()"></p-button>
                        @if (editingTelefoneIndex >= 0) {
                            <p-button label="Cancelar" [text]="true" (onClick)="cancelarEdicaoTelefone()"></p-button>
                        }
                    </div>
                </div>
            </app-card-content>

            <!-- Telefones Adicionados -->
            <app-card-content [headerColor]="false" icon="pi pi-list" title="Telefones Adicionados">
                <p-table [value]="novoTelefones()" [tableStyle]="{ 'min-width': '40rem' }" stripedRows>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Tipo</th>
                            <th>DDD</th>
                            <th>Número de Telefone</th>
                            <th>Observação</th>
                            <th style="width: 120px">Ações</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                        <tr>
                            <td>{{ getTipoLabel(row.inTipoTelefone, tiposTelefone) }}</td>
                            <td>{{ row.nuDdd }}</td>
                            <td>{{ row.nuTelefone }}</td>
                            <td>{{ row.txObservacao }}</td>
                            <td>
                                <div class="flex gap-2">
                                    <p-button icon="pi pi-pencil" (onClick)="editarTelefone(rowIndex)" severity="info" [text]="true" [rounded]="true" pTooltip="Editar"></p-button>
                                    <p-button icon="pi pi-trash" (onClick)="removerTelefone(rowIndex)" severity="danger" [text]="true" [rounded]="true" pTooltip="Remover"></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="5" style="text-align: center">
                                <div class="table-empty-state">
                                    <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                                    <p class="table-empty-state-title">Nenhum telefone cadastrado</p>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        </div>
    }

    @if (novoStep === 2) {
        <div class="flex flex-col gap-4">
            <!-- Novo Horário -->
            <app-card-content [headerColor]="false" icon="pi pi-clock" title="Novo Horário">
                <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div class="md:col-span-2">
                        <label class="font-semibold block mb-2">Dia Início</label>
                        <p-select [appendTo]="'body'" class="w-full" [options]="diasSemana" optionLabel="label" optionValue="value" [(ngModel)]="novoHorario.idDiaSemanaInicio" placeholder="Selecione" [style]="{ width: '100%' }"></p-select>
                    </div>
                    <div class="md:col-span-2">
                        <label class="font-semibold block mb-2">Dia Fim</label>
                        <p-select [appendTo]="'body'" class="w-full" [options]="diasSemana" optionLabel="label" optionValue="value" [(ngModel)]="novoHorario.idDiaSemanaFim" placeholder="Selecione" [style]="{ width: '100%' }"></p-select>
                    </div>

                    <div>
                        <label class="font-semibold block mb-2">Manhã Início</label>
                        <p-inputmask mask="99:99" class="w-full" [(ngModel)]="novoHorario.dsHoraManhaInicio" placeholder="HH:MM"></p-inputmask>
                    </div>
                    <div>
                        <label class="font-semibold block mb-2">Manhã Fim</label>
                        <p-inputmask mask="99:99" class="w-full" [(ngModel)]="novoHorario.dsHoraManhaFim" placeholder="HH:MM"></p-inputmask>
                    </div>
                    <div>
                        <label class="font-semibold block mb-2">Tarde Início</label>
                        <p-inputmask mask="99:99" class="w-full" [(ngModel)]="novoHorario.dsHoraTardeInicio" placeholder="HH:MM"></p-inputmask>
                    </div>
                    <div>
                        <label class="font-semibold block mb-2">Tarde Fim</label>
                        <p-inputmask mask="99:99" class="w-full" [(ngModel)]="novoHorario.dsHoraTardeFim" placeholder="HH:MM"></p-inputmask>
                    </div>

                    <div class="md:col-span-4 flex items-center justify-end gap-2 mt-2">
                        <p-button [label]="editingHorarioIndex >= 0 ? 'Salvar' : 'Adicionar Horário'" icon="pi pi-check" (onClick)="adicionarHorario()"></p-button>
                        @if (editingHorarioIndex >= 0) {
                            <p-button label="Cancelar" [text]="true" (onClick)="cancelarEdicaoHorario()"></p-button>
                        }
                    </div>
                </div>
            </app-card-content>

            <!-- Horários Adicionados -->
            <app-card-content [headerColor]="false" icon="pi pi-calendar" title="Horários Adicionados">
                <p-table [value]="novoHorarios()" stripedRows>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Dia Início</th>
                            <th>Dia Fim</th>
                            <th>Manhã</th>
                            <th>Tarde</th>
                            <th style="width: 120px">Ações</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                        <tr>
                            <td>{{ getTipoLabel(row.idDiaSemanaInicio, diasSemana) }}</td>
                            <td>{{ getTipoLabel(row.idDiaSemanaFim, diasSemana) }}</td>
                            <td>{{ row.dsHoraManhaInicio }} - {{ row.dsHoraManhaFim }}</td>
                            <td>{{ row.dsHoraTardeInicio }} - {{ row.dsHoraTardeFim }}</td>
                            <td>
                                <div class="flex gap-2">
                                    <p-button icon="pi pi-pencil" (onClick)="editarHorario(rowIndex)" severity="info" [text]="true" [rounded]="true"></p-button>
                                    <p-button icon="pi pi-trash" (onClick)="removerHorario(rowIndex)" severity="danger" [text]="true" [rounded]="true"></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="5" style="text-align: center">
                                <div class="table-empty-state">
                                    <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                                    <p class="table-empty-state-title">Nenhum horário cadastrado</p>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        </div>
    }

    @if (novoForm.controls.inUso.value === 'C' && novoStep === compartStepIndex) {
        <app-consultorio-compartilhamento [pessoa]="pessoa()" [idConsultorio]="null" [autoEdit]="true" (rowsChange)="onCompartRowsChange($event)"></app-consultorio-compartilhamento>
    }

    @if (novoForm.controls.inEspecializado.value && novoStep === especialStepIndex) {
        <div class="flex flex-col gap-4">
            <!-- Nova Especialidade -->
            <app-card-content [headerColor]="false" icon="pi pi-star" title="Nova Especialidade">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label class="font-semibold block mb-2">Especialidade</label>
                        <p-select
                            [appendTo]="'body'"
                            class="w-full"
                            [options]="especialidadesLista()"
                            optionLabel="dsEspecialidade"
                            optionValue="idEspecialidade"
                            [ngModel]="especialidadeSelecionada"
                            (ngModelChange)="onEspecialidadeSelecionadaChange($event)"
                            placeholder="Selecione"
                            [style]="{ width: '100%' }"
                        ></p-select>
                    </div>
                    <div>
                        <label class="font-semibold block mb-2">Área de Atuação</label>
                        <p-select
                            [appendTo]="'body'"
                            class="w-full"
                            [options]="areasAtuacaoLista()"
                            optionLabel="dsAreaAtuacao"
                            optionValue="idAreaAtuacao"
                            [(ngModel)]="areaAtuacao"
                            [disabled]="!areasAtuacaoLista().length"
                            placeholder="Selecione"
                            [style]="{ width: '100%' }"
                        ></p-select>
                    </div>

                    <div class="md:col-span-2 flex items-center justify-end gap-2 mt-2">
                        <p-button label="Adicionar" icon="pi pi-plus" (onClick)="adicionarEspecialidade()"></p-button>
                    </div>
                </div>
            </app-card-content>

            <!-- Especialidades Adicionadas -->
            <app-card-content [headerColor]="false" icon="pi pi-list" title="Especialidades Adicionadas">
                <p-table [value]="especialidadesSelecionadas" [tableStyle]="{ 'min-width': '40rem' }" stripedRows>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Especialidade</th>
                            <th>Área de Atuação</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-esp>
                        <tr>
                            <td>{{ esp.dsEspecialidade }}</td>
                            <td>{{ esp.dsAreaAtuacao }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="2" style="text-align: center">
                                <div class="table-empty-state">
                                    <span class="table-empty-state-icon"><i class="pi pi-search"></i></span>
                                    <p class="table-empty-state-title">Nenhuma especialidade selecionada</p>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </app-card-content>
        </div>
    }

    <!-- Modal Selecionar Município -->
    <p-dialog appDialogoPadrao="pi pi-map-marker" descricao="Município do endereço do consultório." header="Selecionar Município" [(visible)]="dialogMunicipioVisivel" [style]="{ width: '52rem', maxWidth: '95vw' }" (onHide)="fecharDialogMunicipio()">
        <app-select-municipio [(idMunicipio)]="municipioDialogId" [showActions]="false" [minCharsToEnable]="1"></app-select-municipio>
        <ng-template pTemplate="footer">
            <div class="flex justify-end gap-2">
                <p-button label="Cancelar" severity="secondary" (onClick)="fecharDialogMunicipio()"></p-button>
                <p-button label="Selecionar" icon="pi pi-check" (onClick)="confirmarMunicipioDialog()" [disabled]="!municipioDialogId"></p-button>
            </div>
        </ng-template>
    </p-dialog>

    <!-- Botões de Navegação do Wizard -->
    <div class="flex items-center justify-between gap-2 mt-8 pt-4 border-t border-surface-200">
        <div>
            <p-button label="Voltar" icon="pi pi-arrow-left" [text]="true" (onClick)="prevNovo()" [disabled]="novoStep === 0"></p-button>
        </div>
        <div class="flex items-center gap-2">
            <p-button label="Cancelar" [text]="true" (onClick)="close()"></p-button>
            @if (novoStep < novoMaxStep) {
                <p-button label="Avançar" icon="pi pi-arrow-right" iconPos="right" (onClick)="nextNovo()"></p-button>
            } @else {
                <p-button label="Salvar" icon="pi pi-check" [loading]="criando()" (onClick)="criarConsultorio()"></p-button>
            }
        </div>
    </div>
</app-card-content>
